var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibilityOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.45012 16.9201C4.34895 15.8763 3.48007 14.6122 2.90012 13.2101C2.80108 12.9795 2.75 12.7311 2.75 12.4801C2.75 12.2291 2.80108 11.9807 2.90012 11.7501C3.67032 9.87648 4.96127 8.2628 6.62012 7.1001C8.19462 5.99981 10.0799 5.43214 12.0001 5.4801C13.3817 5.44541 14.752 5.7366 16.0001 6.3301M18.5601 8.0501C19.6554 9.09294 20.5206 10.3532 21.1001 11.7501C21.1992 11.9807 21.2502 12.2291 21.2502 12.4801C21.2502 12.7311 21.1992 12.9795 21.1001 13.2101C20.3299 15.0837 19.039 16.6974 17.3801 17.8601C15.8056 18.9604 13.9204 19.5281 12.0001 19.4801C10.6185 19.5148 9.24821 19.2236 8.00012 18.6301",
    stroke: "#A3AED0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71 13.65C8.56976 13.2759 8.4986 12.8795 8.5 12.48C8.5 11.5517 8.86875 10.6615 9.52513 10.0051C10.1815 9.34875 11.0717 8.98 12 8.98C12.4 8.978 12.796 9.05 13.17 9.19M15.29 11.31C15.43 11.684 15.502 12.08 15.5 12.48C15.5 13.4083 15.1313 14.2985 14.4749 14.9549C13.8185 15.6113 12.9283 15.98 12 15.98C11.6005 15.9814 11.2041 15.9102 10.83 15.77M3 20L19 4",
    stroke: "#A3AED0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityOff);
export default __webpack_public_path__ + "static/media/visibility_off.ff636cb090e16dae5d64c62afa27cb35.svg";
export { ForwardRef as ReactComponent };